import { CLOSE_OPEN_POPUP, SET_OPEN_POPUP, SET_OPEN_POPUP_DATA } from './types';

export const setOpenPopup = (data) => ({
  type: SET_OPEN_POPUP,
  payload: data,
});

export const clostOpenPopup = (data) => ({
  type: CLOSE_OPEN_POPUP,
  payload: data,
});

export const setOpenPopupData = (data) => ({
  type: SET_OPEN_POPUP_DATA,
  payload: data,
});
